module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/components/project-materials-substage/project-materials-substage.component.scss
// module id = ./src/app/components/project-materials-substage/project-materials-substage.component.scss
// module chunks = main